import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { ImpersonationErrorComponent } from './impersonation-error.component';
import { ImpersonationErrorRoutingModule } from './impersonation-error-routing.module';
import { SvgModule } from '@n2p/svg';

@NgModule({
	declarations: [ImpersonationErrorComponent],
	imports: [RouterModule, ImpersonationErrorRoutingModule, CommonModule, SvgModule, TranslateModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ImpersonationErrorModule {}
